import script from "./EstimateReview.vue?vue&type=script&setup=true&lang=js"
export * from "./EstimateReview.vue?vue&type=script&setup=true&lang=js"

import "./EstimateReview.vue?vue&type=style&index=0&id=636ac220&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636ac220"]])

export default __exports__